export const BrandLogo = ({ className = "text-4xl" }) => (
  <span data-testid="brand-logo" className={`font-display font-black tracking-widest uppercase select-none logo-glow ${className}`}>
    <span className="neon-cyan">IBE</span>
    <span className="neon-pink">FLIX</span>
  </span>
);

export default BrandLogo;
